import React from "react";
import ApiKeyList from './ApiKeyList'

const ApiManagement = () => {
  return (
    <div className="api-management-container">
      <ApiKeyList />
    </div>
  );
};

export default ApiManagement;
